import React from 'react';
import { FieldProps } from 'react-jsonschema-form';

function BooleanFieldComponent(props: FieldProps) {
  return (
    <div className="form-group field field-boolean">
      <div className="checkbox">
        <label htmlFor={props.idSchema.$id}>
          <input
            type="checkbox"
            id={props.idSchema.$id}
            checked={props.formData || false}
            onChange={(event) => props.onChange(event.target.checked)}
          />
          <span>{props.schema.title}</span>
        </label>
      </div>
    </div>
  );
}

export default BooleanFieldComponent;
